import React from "react";
import { Typography } from "@mui/material";
import { HasClassName } from "@lib/types";
import { makeStyles } from "@providers/Mui";
import clsx from "clsx";

type SubtitleProps = HasClassName & {};

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: 14,
    color: theme.palette.grey[800],
  },
}));

export const Subtitle: React.FC<SubtitleProps> = ({ children, className }) => {
  const classes = useStyles();
  return (
    <Typography variant="subtitle1" fontWeight="bold" className={clsx(classes.root, className)}>
      {children}
    </Typography>
  );
};
